import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ParallaxElement } from './';

class FireAndForgetElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inView: false,
    };
  }
  
  inViewCallback = inView => {
    const oldState = this.state.inView;
    if (inView === oldState) return;
    this.setState({
      inView,
    });
  };

  render() {
    const { Tag, className, children } = this.props;
    const classname = classnames(className, {
      initial: !this.state.inView,
    });

    return (
      <ParallaxElement className={classname} Tag={Tag} inViewCallback={this.inViewCallback}>
        {children}
      </ParallaxElement>
    );
  }
}

FireAndForgetElement.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  className: PropTypes.string,
  Tag: PropTypes.string,
};

FireAndForgetElement.defaultProps = {
  Tag: 'div',
};

export default FireAndForgetElement;



// WEBPACK FOOTER //
// ./src/modules/parallax/components/FireAndForgetElement.js